"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scribe = void 0;
var tslib_1 = require("tslib");
var moment_1 = tslib_1.__importDefault(require("moment"));
var base_service_1 = require("../base-service");
var v2_1 = require("./v2");
var Scribe = /** @class */ (function (_super) {
    tslib_1.__extends(Scribe, _super);
    function Scribe() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * @deprecated please use searchUsers from Scribe.V2 instead
         */
        _this.searchUsers = function (query) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = '/v1/users';
                        return [4 /*yield*/, this.api.get(url, {
                                filter: query,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.handleResponse(null, url, response)];
                }
            });
        }); };
        _this.createUserCharge = function (userId, amount, description, episodeId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, attributes, meta, payload, res, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/v1/users/".concat(userId, "/charges");
                        attributes = { amount: amount, description: description };
                        if (episodeId) {
                            meta = { episode_id: episodeId };
                            attributes.meta = meta;
                        }
                        payload = {
                            data: {
                                type: 'charge',
                                attributes: attributes,
                            },
                        };
                        return [4 /*yield*/, this.api.post(url, payload)];
                    case 1:
                        res = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, res)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.deleteUserCharge = function (chargeId, reason) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, payload, res, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/v1/charges/".concat(chargeId);
                        payload = {
                            data: {
                                type: 'charge',
                                attributes: {
                                    reason: reason,
                                },
                            },
                        };
                        return [4 /*yield*/, this.api.delete(url, undefined, { data: payload })];
                    case 1:
                        res = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, res)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.getUserCharges = function (userId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, res, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/v1/users/".concat(userId, "/charges");
                        return [4 /*yield*/, this.api.get(url)];
                    case 1:
                        res = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, res)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.getFamilyMembers = function (memberId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, res, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/v1/users/".concat(memberId, "/family_members");
                        return [4 /*yield*/, this.api.get(url)];
                    case 1:
                        res = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, res)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.createFamilyDependent = function (memberId, attributes, type) {
            if (type === void 0) { type = 'guardian'; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var url, payload, res, data;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/v1/users/".concat(memberId, "/family_members");
                            payload = {
                                data: {
                                    type: 'family_member',
                                    attributes: tslib_1.__assign(tslib_1.__assign({}, attributes), { type: type }),
                                },
                            };
                            return [4 /*yield*/, this.api.post(url, payload)];
                        case 1:
                            res = _a.sent();
                            return [4 /*yield*/, this.handleResponse(null, url, res)];
                        case 2:
                            data = (_a.sent()).data;
                            return [2 /*return*/, data];
                    }
                });
            });
        };
        _this.createFamilyChild = function (memberId, attributes) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, birthdate, payload, res, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/v1/users/".concat(memberId, "/children");
                        birthdate = (0, moment_1.default)(attributes === null || attributes === void 0 ? void 0 : attributes.birthdate).format('YYYY-MM-DD');
                        payload = {
                            data: {
                                type: 'child',
                                attributes: tslib_1.__assign(tslib_1.__assign({}, attributes), { birthdate: birthdate }),
                            },
                        };
                        return [4 /*yield*/, this.api.post(url, payload)];
                    case 1:
                        res = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, res)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        return _this;
    }
    Scribe.V2 = v2_1.ScribeV2;
    return Scribe;
}(base_service_1.BaseService));
exports.Scribe = Scribe;
